import { useAppDispatch } from "@hook/useAppDispatch"
import { useAppSelector } from "@hook/useAppSelector"
import { callAddGroupTelesales, resetDataTelesalesGroups } from "@reducer/version2/product-detail"
import { callGetGroupsSuggest } from "@reducer/version2/product-detail"
import { trans } from "@resources/localization"
import { AutoComplete, Button, Col, Form, message, Row, Space, Spin } from "antd"
import { debounce } from "lodash"
import React, { useEffect, useMemo } from "react"
import { useParams } from "react-router-dom"

type Props = {
    setClose: () => void
}
export const AddGroup: React.FC<Props> = ({ setClose }) => {
    const { id } = useParams()
    const [formRef] = Form.useForm()
    const dispatch = useAppDispatch()
    const groupsTelesales = useAppSelector((state) => state.productDetail.groupsSuggest)
    const loadingAdd = useAppSelector((state) => state.productDetail.loadingAddGroups)
    useEffect(() => {
        dispatch(
            callGetGroupsSuggest({
                code: id?.toString() || "",
                params: {
                    keyword: "",
                },
            })
        )
    }, [dispatch])
    const onSearchGroupsTelesales = (searchText: string) => {
        if (searchText.trim().length >= 3) {
            dispatch(
                callGetGroupsSuggest({
                    code: id?.toString() || "",
                    params: {
                        keyword: searchText?.trim(),
                    },
                })
            )
        } else {
            dispatch(
                callGetGroupsSuggest({
                    code: id?.toString() || "",
                    params: {
                        keyword: "",
                    },
                })
            )
        }
    }
    const options = useMemo(
        () =>
            groupsTelesales?.map((item) => ({
                value: item?.name,
                key: item?.code,
            })),
        [groupsTelesales]
    )
    const addGroupIntoProduct = (values: { groupCodes: string }) => {
        dispatch(
            callAddGroupTelesales({
                code: id || "",
                body: {
                    groupCodes: [values.groupCodes],
                },
            })
        ).then((result: any) => {
            if (result?.payload?.status === 200) {
                message.success(trans("message.success"))
                formRef.resetFields()
                setClose()
            } else {
                message.error(result?.payload?.response?.data?.message || trans("message.fail"))
            }
        })
    }
    return (
        <div className="w-72">
            <Form
                form={formRef}
                layout="vertical"
                onFinish={addGroupIntoProduct}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            name="groupCodes"
                            hidden></Form.Item>
                        <Form.Item
                            label={trans("products.group_name")}
                            name="groupName"
                            rules={[{ required: true, message: trans("message.required") }]}>
                            <AutoComplete
                                notFoundContent={<Spin />}
                                allowClear
                                onSearch={debounce(onSearchGroupsTelesales, 1000)}
                                placeholder={trans("products.group_name")}
                                options={options}
                                onSelect={(val: any, option: any) => {
                                    formRef.setFieldsValue({
                                        groupCodes: option?.key,
                                    })
                                }}
                                onBlur={() => {
                                    if (!formRef.getFieldValue("groupCodes")) {
                                        formRef.setFieldsValue({
                                            groupName: "",
                                        })
                                        dispatch(resetDataTelesalesGroups([]))
                                    }
                                }}
                                onKeyDown={(e) => (e.keyCode == 13 ? e.preventDefault() : "")}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify="end">
                    <Space>
                        <Button
                            type="default"
                            loading={loadingAdd}
                            onClick={() => {
                                formRef.resetFields()
                                setClose()
                            }}>
                            {trans("button.cancel")}
                        </Button>
                        <Button
                            type="primary"
                            loading={loadingAdd}
                            htmlType="submit"
                            className="ml-2">
                            {trans("button.add")}
                        </Button>
                    </Space>
                </Row>
            </Form>
        </div>
    )
}
